import { render, staticRenderFns } from "./EditorWalletBank.vue?vue&type=template&id=15bc83fb&scoped=true&"
import script from "./EditorWalletBank.vue?vue&type=script&lang=js&"
export * from "./EditorWalletBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc83fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15bc83fb')) {
      api.createRecord('15bc83fb', component.options)
    } else {
      api.reload('15bc83fb', component.options)
    }
    module.hot.accept("./EditorWalletBank.vue?vue&type=template&id=15bc83fb&scoped=true&", function () {
      api.rerender('15bc83fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorWalletBank.vue"
export default component.exports